import { useCallback, useEffect, useState } from 'react'

import { useSetUserLocation } from '@enlyt/base/stores/Locations/Hooks'

export const useUserLocation = () => {
  const setLocation = useSetUserLocation()
  const [userLocation, setUserLocation] = useState({})
  const [isReady, setIsReady] = useState(false)

  const successCallback = useCallback(
    position => {
      setUserLocation({
        lng: position.coords.longitude,
        lat: position.coords.latitude
      })

      setLocation({
        longitude: position.coords.longitude,
        latitude: position.coords.latitude
      })

      setIsReady(true)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const errorCallback = useCallback(
    () => {
      setUserLocation(null)
      setLocation(null)
      setIsReady(true)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(
    () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return {
    userLocation,
    isLocationPermissionAllowed: !!userLocation,
    isUserLocationReady: isReady
  }
}
